import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const NotificationEmailLogList = Loadable(
  lazy(() => import("features/notification/logsEmail/components/List"))
);

const routes = {
  path: "email",
  children: [{ path: "", element: <NotificationEmailLogList /> }],
};

export default routes;
